import { render, staticRenderFns } from "./apgarHistoria.vue?vue&type=template&id=63cdc43d"
import script from "./apgarHistoria.vue?vue&type=script&lang=js"
export * from "./apgarHistoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports